<template class="c-ToolPanel">
    <v-card class="c-ToolPanel_1 mx-auto w-100 pa-0" style="width: 100%; display: flex; flex-direction: row; max-width: 750px;" v-if="isvisible" :elevation="0">
        <v-card class="mx-auto w-100 pa-0" style="overflow: auto; width: 100%; flex-grow: 1; display: flex; flex-direction: column;" :elevation="0" color="grey lighten-5">
            <v-card-subtitle class="mt-0 consistentText">
                <span style="display: flex; align-items: flex-end;" class="mb-1">
                    {{ Translate('Constrain the source data by the field values you choose.') }}
                    <v-spacer></v-spacer>
                    <v-switch dense hide-details inset :label="Translate('Advanced settings')" class="ma-0" v-model="advancedSettings"></v-switch>
                </span>
            </v-card-subtitle>

            <v-text-field outlined dense hide-details clearable :label="Translate('Search')" v-model="search" class="mb-4" background-color="white">
                <template v-slot:prepend-inner>
                    <v-icon>mdi-magnify</v-icon>
                </template>
                <!--<template v-slot:append-outer>

            <v-menu offset-y :close-on-content-click="false" :close-on-click="false" v-model="filter_menuopen">
                <template v-slot:activator="{ on, attrs }">
                    <v-badge color="primary" dot offset-y="25" offset-x="10" :value="anyFilters">
                        <v-btn icon small v-bind="attrs" v-on="on" class="ma-0">
                            <v-icon>mdi-filter</v-icon>
                        </v-btn>
                    </v-badge>
                </template>
                <v-card @mouseleave="filter_menuopen = false" class="pa-1" style="_max-height: 520px; min-width: 400px;">
                    <MetricTypeFilter :debugMode="debugMode"
                                      :datatypes="filterDataTypes"
                                      :initial_datatypes_selection="filterDataTypes_selection"
                                      @datatypes_changed="(values) => filterDataTypes_selection = values"
                                      :categories="filterCategories"
                                      :initial_category_selection="filterCategory_selection"
                                      @categories_changed="(values) => filterCategory_selection = values"
                                      :sources="filterSources"
                                      :initial_sources_selection="filterSources_selection"
                                      @sources_changed="(values) => filterSources_selection = values"
                                      @anyfilters="(value) => anyFilters = value">

                    </MetricTypeFilter>
                </v-card>
            </v-menu>

        </template>-->
            </v-text-field>

            <div v-show="!search && metricColumns.length > 0">
                <v-alert v-if="showwarn" dense dark text color="outbound">
                    <template slot="prepend">
                        <v-icon color="outbound" class="mr-4">
                            mdi-alert
                        </v-icon>
                    </template>
                    {{ Translate('Filtering displayed metrics may hide rows in the grid, but totals will still reflect all data. Filtering on non-displayed metrics, both the grid and totals will adjust to reflect filtered content.') }}
                </v-alert>

                <v-card-subtitle style="border-bottom: 2px solid silver; color: #9d9d9d;">{{ Translate('METRICS') }}</v-card-subtitle>

                <FilterCategory :columns="metricColumns"
                                :column_filters="column_filters"
                                :initial_column_filters="initial_column_filters"
                                :settings="settings"
                                :ReadOnly="ReadOnly"
                                :advancedSettings="advancedSettings"
                                :getColumnComponent="getColumnComponent"
                                :getFilterValue="getFilterValue"
                                :updateFilterValue="updateFilterValue"
                                :EventBus="EventBus"></FilterCategory>
            </div>

            <div v-show="!search" v-for="(cat,k) in filterCategoriesList" :key="k">
                <v-card-subtitle v-if="isCategoryVisible(cat)" class="consistentText" style="border-bottom: 2px solid silver;">{{ filterCategoryPrefix(cat).toUpperCase() }}</v-card-subtitle>

                <v-expansion-panels v-if="isCategoryVisible(cat)"
                                    multiple hover accordion :value="categoryPanels[cat]" @change="(value) => setPanelState(cat,value)">

                    <FilterCategory :columns="getColumnsByCategory(cat)"
                                    :column_filters="column_filters"
                                    :initial_column_filters="initial_column_filters"
                                    :settings="settings"
                                    :ReadOnly="ReadOnly"
                                    :advancedSettings="advancedSettings"
                                    :getColumnComponent="getColumnComponent"
                                    :getFilterValue="getFilterValue"
                                    :updateFilterValue="updateFilterValue"
                                    :EventBus="EventBus"></FilterCategory>

                </v-expansion-panels>
            </div>

            <div v-if="search">
                <v-card-subtitle class="consistentText" style="border-bottom: 2px solid silver;">{{ Translate('SEARCH RESULTS') }}</v-card-subtitle>

                <FilterCategory :columns="columnsFromSearch"
                                :column_filters="column_filters"
                                :initial_column_filters="initial_column_filters"
                                :settings="settings"
                                :ReadOnly="ReadOnly"
                                :advancedSettings="advancedSettings"
                                :getColumnComponent="getColumnComponent"
                                :getFilterValue="getFilterValue"
                                :updateFilterValue="updateFilterValue"
                                :EventBus="EventBus"></FilterCategory>
            </div>

            <div style="justify-content: unset; border-top: 1px solid #e0e0e0;" class="mt-1">
                <v-btn v-if="!ReadOnly" text large elevation="0" color="primary" class="px-0 customHoverButton mt-1"
                       @click="addFilter">
                    <v-icon small class="mr-1">mdi-plus</v-icon>
                    {{ Translate('Add Filter') }}
                </v-btn>
            </div>
            <!--<v-hover>
                <v-btn v-if="!ReadOnly" elevation="0" class="px-0 customHoverButton" @click="addFilter">
                    <v-icon left class="mr-1">
                        mdi-plus
                    </v-icon>
                    Add Filter
                </v-btn>
            </v-hover>-->
        </v-card>

        <v-dialog v-model="addFilterVisible" max-width="590" persistent>
            <v-card>
                <v-card-title class="text-h6">
                    {{ Translate('Select filters') }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="addFilterVisible = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>

                <v-card-text>
                    <v-menu offset-y nudge-top="25" v-model="menuSelectFiltersOpen">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field ref="search_dlg_field"
                                          style="cursor: text !important;"
                                          outlined
                                          dense
                                          clearable
                                          :placeholder="Translate('Search')"
                                          prepend-inner-icon="mdi-magnify"
                                          v-model="search_dlg" v-bind="attrs" v-on="on"
                                          @input="menuSelectFiltersOpen = true">
                                <template v-slot:append>
                                    <v-icon v-bind="attrs" v-on="on">mdi-menu-down</v-icon>
                                </template>
                            </v-text-field>
                        </template>

                        <v-list style="max-height: 400px; overflow-y: auto;" subheader flat>
                            <v-list-item-group v-if="columnsFromSearch_dlg.length > 0" :value="search_colid" _change="selectFilterDlgChanged">
                                <template v-for="(item,index) in columnsFromSearch_dlg">
                                    <template v-if="index == 0 || columnsFromSearch_dlg[index].Category != columnsFromSearch_dlg[index - 1].Category">
                                        <v-subheader :key="`head:${index}`" class="ml-2 pl-0">{{ item.Category.toUpperCase() }}</v-subheader>
                                        <v-divider :key="`div:${index}`"></v-divider>
                                    </template>

                                    <v-list-item :key="`body:${index}`" class="ml-2" :value="item.ColId" :disabled="item.isInUse" @click="selectFilterDlg(item)">
                                        <v-list-item-title>
                                            {{ item.Title }}
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                            </v-list-item-group>
                            <v-list-item v-else>
                                <v-list-item-title>
                                    {{ Translate('No results found') }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="primary"
                           class="mb-3 mr-2"
                           :elevation="0"
                           :disabled="!search_colid || !search_dlg"
                           @click="addFilterResponse(search_colid)">
                        {{ Translate('Select') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    /* eslint-disable */

    import Vue from "vue";
    import utils from '@/Shared/utils.jsx';
    import common from './common.js';
    import methods from '@/Shared/methods';

    import { appSettings } from '@/Shared/appSettings';

    import FilterCategory from './filterCategory.vue';
    import MetricTypeFilter from './metricTypeFilterPopup.vue';
import Enumerable from "linq";

    export default {
        components: {
            FilterCategory,
            MetricTypeFilter,
        },
        props: {
            EventBus: null,
            column_list: {
                type: Array
            },
            column_filters: {
                type: Object
            },
            initial_column_filters: null,
            ReadOnly: null,
            settings: null,
            report_settings: null,
            source: null,
            isvisible: null,
            debugMode: null,
        },
        data: function () {
            return {
                columnLookup: {},
                fieldChoices: [],
                filters: [],
                openpanels: [],
                categoryPanels: {},
                search: '',
                search_dlg: '',
                search_colid: '',
                filter_menuopen: false,
                menuSelectFiltersOpen: false,
                advancedSettings: false,

                filterDataTypes: [
                    { text: 'Counts', filter: 'type', types: ['countColumn', 'floatColumn'] },
                    { text: 'Dates / Times', filter: 'type', types: ['dateColumn', 'dateOnlyColumn', 'timeOnlyColumn'] },
                    { text: 'Durations', filter: 'type', types: ['durationColumn'] },
                    { text: 'Text Values', filter: 'type', types: ['textSetColumn', 'searchableTextColumn', 'channelTypeColumn', 'directionColumn', 'userIDColumn', 'customerIDColumn', 'phoneNumColumn'] },
                    { text: 'True / False', filter: 'type', types: ['booleanColumn'] },
                ],
                filterCategories: [],
                filterSources: [],

                addFilterVisible: false,
                anyFilters: false,

                filterDataTypes_selection: [],
                filterCategory_selection: [],
                filterSources_selection: [],
            }
        },
        watch: {
            filterDataTypes_selection: function (newv) {
                this.saveFilterFilters();
            },
            filterCategory_selection: function (newv) {
                this.saveFilterFilters();
            },
            filterSources_selection: function (newv) {
                this.saveFilterFilters();
            },
            advancedSettings: function (newv) {
                appSettings.LocalStorage(this.storageKey + '-filterFilters-advancedSettings', newv ? 'true' : null);
            },
            //addFilterVisible: function (newv) {
            //    if (newv) {
            //        this.$nextTick(() => {
            //            this.$refs.search_dlg_field.focus();
            //        });
            //    }
            //},
        },
        created() {
            for (let cat of [...new Set(this.column_list.filter(a => a.ColumnUse.Filter).map(a => a.FilterCategory || a.Category))])
                this.categoryPanels[cat] = [];

            console.log('Report Filters, report_settings:');
            console.log(JSON.stringify(this.report_settings, null, 3));

            if (appSettings.LocalStorage(this.storageKey + '-filterFilters-advancedSettings') == 'true')
                this.advancedSettings = true;

            //------------------------ New --------------------//

            // Populate a distinct list of categories for metric filters
            this.filterCategories = [...new Set(this.column_list.filter(a => a.ColumnUse.Filter).map(a => a.FilterCategory || a.Category))]
                .filter(a => a)
                .toSorted((a, b) => common.byField(a, b))
                .map(a => ({ text: a.indexOf('#') <= 1 ? a.substr(a.indexOf('#') + 1) : a, filter: 'Category', category: a }));

            // Populate a distinct list of source names (contacts, users, etc)
            this.filterSources = [...new Set(this.column_list.filter(a => a.ColumnUse.Filter).flatMap(a => a.Sources))]
                .toSorted((a, b) => common.byField(common.sourceTypes[a], common.sourceTypes[b]))
                .map(a => ({ text: a, filter: 'Source', source: a }));

            this.loadFilterFilters();
        },
        mounted() {
            for (let c of this.column_list.filter(a => a.ColumnUse.Filter))
                this.columnLookup[c.ColId] = c;
        },
        computed: {
            filterCategoriesList: function () {
                if (this.ReadOnly)
                    return [...new Set(this.column_list.filter(a => a.ColumnUse.Filter && a.SourceType != 'dateColumn').map(a => a.FilterCategory || a.Category))]
                        .toSorted((a, b) => common.byField(a, b));
                else
                    return [...new Set(this.column_list.filter(a => a.ColumnUse.Filter).map(a => a.FilterCategory || a.Category))]
                        .toSorted((a, b) => common.byField(a, b));
            },

            chosenColumns: function() {
                return this.fieldChoices.map(a => this.columnLookup[a])
                    .toSorted((a, b) => common.byField(a, b, 'Title'));
            },
            filterColumns: function() {
                const cols = this.column_list.filter(a => a.ColumnUse.Filter);
                return cols.toSorted((a, b) => common.byField(a, b, 'Title'));
            },
            metricColumns: function() {
                // These are the fields that are generated by the report - not the source fields.
                // You can filter on either the source fields or the computed metric fields.
                if (!this.report_settings || !this.report_settings.metrics) {
                    console.log('Returning empty metricColumns');
                    return [];
                }

                console.log(`Returning metricColumns with ${this.report_settings.metrics.length} metric(s)`);
                let cols = this.report_settings.metrics.filter(item => item.colId && common.column_lookup[item.colId]?.MetricAggs.Type != 'placeholder').map(item => {
                    const coldef = common.column_lookup[item.colId];
                    const newtype = common.getAggregateColumnType(item.colId, item.function, coldef.SourceType);
                    return {
                        ColumnUse: { Filter: true },
                        ColId: `${item.colId}_${item.function}_agg`,
                        Title: common.formatHeader({ type: newtype, headerName: coldef.Title, aggFunc: item.function }),
                        SourceType: newtype,
                        Category: '0#Metrics',
                    };
                });

                if (this.ReadOnly)
                    cols = cols.filter(c => this.column_filters[c.ColId] && this.column_filters[c.ColId].usage);

                return cols.toSorted((a, b) => common.byField(a, b, 'Title'));
            },
            fieldChoicesText: function() {
                return JSON.stringify(this.fieldChoices);
            },
            columnsFromSearch: function() {
                const s = this.search ? this.search.toLowerCase() : '';
                const cols = this.column_list
                    .filter(a => a.ColumnUse.Filter && a.Title.toLowerCase().includes(s))
                    .concat(this.metricColumns.filter(a => a.Title.toLowerCase().includes(s)))
                    .toSorted((a, b) => common.byField(a, b, 'Title'));

                if (this.ReadOnly)
                    return cols.filter(a => a.ColId != 'datetime' && a.ColId != 'starttime')
                else
                    return cols;
            },
            columnsFromSearch_dlg: function () {
                const s = this.search_dlg ? this.search_dlg.toLowerCase() : '';
                
                let colslist = this.column_list
                    .filter(a => a.ColumnUse.Filter && (a.Title.toLowerCase().includes(s) || (a.FilterCategory || a.Category).toLowerCase().includes(s)))
                    .toSorted((a, b) => {
                        let comp = (a.FilterCategory || a.Category).localeCompare(b.FilterCategory || b.Category);
                        if (comp == 0)
                            comp = a.Title.localeCompare(b.Title);

                        return comp;
                    });

                let metricslist = this.metricColumns
                    .filter(a => a.Title.toLowerCase().includes(s) || (a.FilterCategory || a.Category).toLowerCase().includes(s));

                return metricslist.concat(colslist).map(a => ({
                    ColId: a.ColId,
                    Title: a.Title,
                    Category: this.filterCategoryPrefix(a.FilterCategory || a.Category),
                    isInUse: !!this.column_filters[a.ColId]
                }));
            },
            showwarn: function () {
                return Object.keys(this.column_filters).some(a => a.includes('_agg'));
            },
        },
        methods: {
            ...methods,
            loadFilterFilters() {
                for (let i = 0; i < this.filterDataTypes.length; i++)
                    if (appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterDataTypes[i].text + '-' + (this.source ? `-${this.source}` : '')) != 'hidden')
                        this.filterDataTypes_selection.push(i);

                for (let i = 0; i < this.filterCategories.length; i++)
                    if (appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterCategories[i].text + '-' + (this.source ? `-${this.source}` : '')) != 'hidden')
                        this.filterCategory_selection.push(i);

                if (this.debugMode) {
                    for (let i = 0; i < this.filterSources.length; i++)
                        if (appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterSources[i].text + '-' + (this.source ? `-${this.source}` : '')) != 'hidden')
                            this.filterSources_selection.push(i);
                }
                else
                    this.filterSources_selection = this.filterSources.map((a, i) => i);

                this.anyFilters = 
                    this.filterDataTypes_selection.length < this.filterDataTypes.length ||
                    this.filterCategory_selection.length < this.filterCategories.length ||
                    this.filterSources_selection.length < this.filterSources.length;
            },
            saveFilterFilters() {
                for (let i = 0; i < this.filterDataTypes.length; i++)
                    appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterDataTypes[i].text + '-' + (this.source ? `-${this.source}` : ''), this.filterDataTypes_selection.includes(i) ? null : 'hidden');

                for (let i = 0; i < this.filterCategories.length; i++)
                    appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterCategories[i].text + '-' + (this.source ? `-${this.source}` : ''), this.filterCategory_selection.includes(i) ? null : 'hidden');

                if (this.filterSources)
                    for (let i = 0; i < this.filterSources.length; i++)
                        appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterSources[i].text + '-' + (this.source ? `-${this.source}` : ''), this.filterSources_selection.includes(i) ? null : 'hidden');
            },
            isCategoryVisible(category) {
                const selected = this.filterCategory_selection.map(i => this.filterCategories[i].category);
                const visible = selected.some(a =>  a == category);

                // Return only the categories that have active filters
                const inuse = this.column_list.some(a => a.ColumnUse.Filter && (a.FilterCategory || a.Category) == category && this.column_filters[a.ColId]);

                return visible && inuse;
            },
            getColumnsByCategory(category) {
                const visibletypes = this.filterDataTypes_selection.flatMap(i => this.filterDataTypes[i].types);
                const visiblesources = this.filterSources_selection.map(i => this.filterSources[i].source);

                let res;
                if (this.ReadOnly)
                    res = this.column_list
                        .filter(a => a.SourceType != 'dateColumn' && a.ColumnUse.Filter && (a.FilterCategory || a.Category) == category && visibletypes.includes(a.SourceType) && a.Sources.some(s => visiblesources.includes(s)))
                        .toSorted((a, b) => common.byField(a, b, 'Title'));
                else
                    res = this.column_list
                        .filter(a => a.ColumnUse.Filter && (a.FilterCategory || a.Category) == category && visibletypes.includes(a.SourceType) && a.Sources.some(s => visiblesources.includes(s)))
                        .toSorted((a, b) => common.byField(a, b, 'Title'));

                return res;
            },
            getColumnComponent(item) {
                return `Filter${item.SourceType}`;
            },

            addFilterVisibleDlgState(state) {
                console.log(`addFilterVisibleDlgState(state:${state})`);
                if (state) {
                    this.$nextTick(() => {
                        this.$refs.search_dlg_field.focus();
                    });
                }
            },
            addFilter() {
                this.search_dlg = '';
                this.search_colid = '';
                this.addFilterVisible = true;

                //this.$nextTick(() => {
                //    this.$refs.search_dlg_field.focus();
                //});
                setTimeout(() => {
                    const item = this.$refs.search_dlg_field;
                    if (item) {
                        item.focus();

                        let inputEl = item.$el.querySelector('input');
                        inputEl.select();

                        setTimeout(() => {
                            inputEl.select();
                        }, 200);
                    }
                }, 250);
            },
            addFilterResponse(colId) {
                this.addFilterVisible = false;
                Vue.set(this.column_filters, colId, {
                    usage: 0,
                });
                this.$emit('filterschanged', this.column_filters, colId);

                const eventBus = this.EventBus;
                Vue.nextTick(() => {
                    eventBus.$emit('SetPanelOpenState', colId);
                });
                //this.EventBus.$emit('SetPanelOpenState', colId);
            },
            selectFilterDlg(item) {
                console.log(`selectFilterDlg(item:${JSON.stringify(item)})`);

                this.search_dlg = item.Title;
                this.search_colid = item.ColId;
            },
            selectFilterDlgChanged(colId) {
                if (colId) {
                    const col = this.column_list.find(a => a.ColId == colId);
                    this.search_dlg = col?.Title;
                    this.search_colid = colId;
                    console.log(`selectFilterChanged(colId:${colId}); Title:${col?.Title}`);
                }
            },
            getFilterValue(col) {
                return this.column_filters[col.ColId];
            },
            updateFilterValue(col, value) {
                console.log("Inside updateFilterValue");
                console.log("col is " + JSON.stringify(col));
                console.log("value is " + JSON.stringify(value));
                              
                //Checking if filter is constrained to current user
                if (value && value["cleared"] == 1)
                {
                    var existingFilter = this.column_filters[col.ColId];
                    if (existingFilter && existingFilter["filter"] == "{{CurrentUserID}}")
                    {
                        //Denied attempt to clear filter constrained to current user
                        return;
                    }
                }

                // Sample data format for filterModel
                // { "callerid":    { "filterType": "text",   "type": "contains",    "filter": "5432"} }
                // { "contacttime": { "filterType": "number", "type": "greaterThan", "filter": 60 } }
                // { "answered":    { "filterType": "set",    "values": [ "true" ] } }

                if (value)
                    Vue.set(this.column_filters, col.ColId, value);
                else
                    Vue.delete(this.column_filters, col.ColId);

                //console.log('updating column_filters:');
                //console.log(JSON.stringify(this.column_filters,null,3));

                this.$emit('filterschanged', this.column_filters, col.ColId);
            },
            filterCategoryPrefix(cat) {
                if (!cat) return this.Translate('Unknown');
                const idx = cat.indexOf('#');
                return idx >= 0 && idx < 3 ? cat.substring(idx + 1) : cat;
            },
            includes(arr, value) {
                for(let i=0; i<arr.length; i++) {
                    const v = arr[i];
                    if (v === value)
                        return true;
                }

                return false;
            },
            isFieldOpen(col, index) {
                const cat = col.FilterCategory || col.Category;
                const open = this.includes(this.categoryPanels[cat], index);

                console.log(`-- -- -- isFieldOpen(col:${col.ColId}, index:${index}), cat:${cat}: ${open}`);

                return open;
            },
            setPanelState(cat, value) {
                console.log(`setPanelState(cat:${cat},value:${JSON.stringify(value)}); ${typeof value}`);

                const arr = this.categoryPanels[cat];
                arr.splice(0, arr.length);

                for(let i of value)
                    arr.push(i);

                console.log(`setPanelState(cat:${cat}) arr: ${JSON.stringify(arr)}; ${typeof value}`);
            },

            clearAllFilters() {
                alert('clearAllFilters in report filters');
            },
        }
    }
</script>

<style scoped>
    .columns-three {
        column-count: 3;
    }

    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }

    p {
        font-size: 2em;
        text-align: center;
    }

    .metric_normal {

    }
    .metric_inuse {
        color: cornflowerblue;
    }
    .metric_usedup {
        color: silver;
    }
    .consistentText {
        color: var(--v-black-base) !important; 
        opacity: 0.8 !important; 
        font-size: 14px !important; 
        text-rendering: optimizelegibility !important; 
        letter-spacing:0.1 !important;
    }
    .customHoverButton:before {
        background-color: unset !important;
        transition: unset !important;
    }

    .customHoverButton {
        background-color: unset !important;
        color: var(--v-primary-base);
    }

        .customHoverButton:hover {
            filter: brightness(80%);
        }
</style>